import { capitalize } from '@repo-level/core-front';
import type React from 'react';
import type { FC } from 'react';
import { useMemo } from 'react';
import { ScAnimatedPlaceholder } from '../primitives/styled';
import { ScError, ScInputStructure } from './styled';

export interface InputStructureProps {
  error?: React.ReactNode;
  hideErrorMessage?: boolean;
  hideErrorStyles?: boolean;

  whiteWhenFilled?: boolean;
  grayLight?: boolean;

  disabled?: boolean;
  whiteTextDisabled?: boolean;
  isInputFocused?: boolean;
  successBorder?: boolean;

  animatedPlaceholder?: string;
  addons?: JSX.Element;
  hint?: JSX.Element | null;

  height?: number;
  noBorder?: boolean;
}

export const InputStructure: FC<InputStructureProps> = ({
  error,
  hideErrorMessage = false,
  hideErrorStyles = false,
  children,
  addons,
  animatedPlaceholder,
  hint,
  noBorder,
  successBorder,
  whiteTextDisabled,
  ...props
}) => {
  const isError = useMemo(
    () => !hideErrorMessage && error != null && error !== '',
    [error, hideErrorMessage]
  );

  return (
    <ScInputStructure
      {...props}
      error={!!error}
      noBorder={noBorder}
      successBorder={successBorder}
      whiteTextDisabled={whiteTextDisabled}
      withHint={!!hint}
    >
      {props.isInputFocused && hint}

      <div className="input-container">
        {!noBorder && <div className="border" />}

        {children}

        {animatedPlaceholder && (
          <ScAnimatedPlaceholder>
            {capitalize(animatedPlaceholder)}
          </ScAnimatedPlaceholder>
        )}

        {addons && <div className="addons">{addons}</div>}
      </div>

      {isError && <ScError hideErrorStyles={hideErrorStyles}>{error}</ScError>}
    </ScInputStructure>
  );
};
